import { Avatar } from '@mui/material';
import { selectUser } from 'features/auth/store/authSelectors';
import { useAppSelector } from 'features/store/hooks';
import { getInitials } from 'shared/utils/getInitials';

type InitialsAvatarProps = {
  /** Box edge in px, default 40. */
  size?: number;
};

/** The signed-in user's initials in a primary-tinted circle (opaque — it can
 *  sit on the patterned shell background). */
export const InitialsAvatar = ({ size = 40 }: InitialsAvatarProps) => {
  const user = useAppSelector(selectUser);
  return (
    <Avatar
      sx={theme => ({
        width: size,
        height: size,
        bgcolor: theme.ui.primarySurface,
        color: 'primary.main',
        fontSize: Math.round(size * 0.35),
        fontWeight: 700,
      })}
    >
      {getInitials(user.displayName ?? '')}
    </Avatar>
  );
};
